import * as types from '@/constants/mutationTypes'

const state = {
  updateThreadStore: '',
  activeEmail: {},
  inboxEmail: [],
  sentEmail: [],
  trashEmail: [],
  savedEmail: [],
  todoEmail: [],
  draftEmail: [],
  emailStore: [
    // {
    //   '_id': '612cce686121910019e80b26',
    //   'accountBalance': 43860.25,
    //   'listOfCompanies': [],
    //   'email': [
    //     'roman.stasenok76@gmail.com'
    //   ],
    //   'languages': [
    //     2
    //   ],
    //   'residentialAddress': [],
    //   'passports': [
    //     {
    //       '_id': '621e24c702066e001953be46',
    //       'number': '',
    //       'citizenship': '',
    //       'date': '2021-11-10T12:26:24.896Z'
    //     }
    //   ],
    //   'banks': [
    //     {
    //       '_id': '621e24c702066e001953be45',
    //       'bankName': 0,
    //       'bankNo': ''
    //     }
    //   ],
    //   'projectManager': {
    //     '_id': '5fa904bc05814400199e1f5a',
    //     'kpi': {
    //       'bonusToBePaid': 0,
    //       'earned': 0,
    //       'potential': 0
    //     },
    //     'isNotAssigned': false,
    //     'massMailingCheck': false,
    //     'lastName': 'lucky',
    //     'firstName': 'adamo',
    //     'email': 'ladamo21@goo.ne.jp',
    //     'username': 'adamo lucky',
    //     'role': 'employee',
    //     'login': 'ladamo21@goo.ne.jp',
    //     'company': '5e09ca8f0e8c600011e57b72',
    //     'salt': 'b8a1d1b329f9968ea0c9019fd5ca6896',
    //     'hash': '3d2effb3c42326d99cedbc2246214aecd05d7f37855a86e99a8c4de7d8e864a81e5f1817227d6c4641b72ae6813cd0541251f18d477c348c11a93c83b950c9aa3beb2136eb4492b1782a0bfac93b1920191dc0df8e3a324252d58097c798a75458316509bbeafac0a8e933c0ac84298ce1bd11aaf9d72e46b9f9133ad81941ae6c3181c2c72c66dcb4214ea6f35e1d3daa99db5ca7859685ea2e1bdac43a87c3ff70eb497c920c6c6056c41a20f05a209c4196576496898641918ccc913b79622790357b3cb1fe9b538936c572949449e38d5a47c70f03829f2ac4cf98bb7cb46195277dec4036922be6356618f3494ec18249f62a4406f3be221627442f59091472737d8a2ea0beead9af09d9d8ee60a5bfc5717d56b195b3e8bc9bc52112d79595fe0030e93e0ebfd42020e1ccd1bac80510de7553a05e515cd307d18abcf78bdddaf8036f0bbfd09b4ab0d932482c6234f98502613f51ffbb4b2a357abf2eaf6d25f1b0294eb655924bd2d25d4aff7acfd52f1b2c417f3254667155c7f83c1c7ab603b2ad53faa6fd2e0baf525ac0308c2bccbc6b5da43c9ccef2a2b79f681bd58ea2998354731126292520550b9f4adfae2f1a5d3b553968c2b93fb8fcb4f647f1d7d3fc70ad870f6c413cb742b03c61b7c456ab214b609377da3eca165be1f141ac3421649749634c28727bec6831bffbc19837911e91d6d953fa52264f',
    //     'createdAt': '2020-11-09T08:58:36.706Z',
    //     'updatedAt': '2022-05-06T11:07:52.270Z',
    //     '__v': 0,
    //     'access': {
    //       'commercialoffers': {
    //         'commercialoffers': false
    //       },
    //       'communications': {
    //         'communications': true,
    //         'hr': true,
    //         'internalCommunication': true,
    //         'inspectionsAndReport': true
    //       },
    //       'dissemination': {
    //         'dissemination': true,
    //         'promotionMarketing': true,
    //         'publicationsPR': true,
    //         'salesCRM': true
    //       },
    //       'finance': {
    //         'finance': true,
    //         'income': true,
    //         'expenses': true,
    //         'assetsMaterialsRecords': true,
    //         'assets': true,
    //         'kpi': true
    //       },
    //       'services': {
    //         'services': true,
    //         'interns': true,
    //         'projectManagement': true,
    //         'businessConsulting': true
    //       },
    //       'qualifications': {
    //         'qualifications': true,
    //         'qualityControl': true,
    //         'educationAcademy': true,
    //         'certificationsAwards': true
    //       },
    //       'businessDevelopment': {
    //         'businessDevelopment': true,
    //         'partnersAndReferals': true,
    //         'businessClubsAssociacions': true,
    //         'publicInformationService': true
    //       },
    //       'executive': {
    //         'executive': true,
    //         'officeOfFounder': true,
    //         'officeOfCorpAffairs': true,
    //         'officeOfTheCEO': true
    //       },
    //       'crm': {
    //         'crm': true,
    //         'clientTrackingList': true,
    //         'listOfProjects': true,
    //         'listOfRequests': true
    //       },
    //       'hr': {
    //         'hr': false,
    //         'documentList': false,
    //         'timeOff': false,
    //         'assets': false,
    //         'hrLetters': false,
    //         'reports': false
    //       }
    //     },
    //     'phone': '+375 44 123 12 12',
    //     'position': '5e09cabc0e8c600011e57b74',
    //     'isHrIncluded': true,
    //     'deleteStatus': 1,
    //     'disciplinaryAction': 'rthrthrth',
    //     'nextAssessment': '2022-04-08T00:00:00.000Z',
    //     'id': '5fa904bc05814400199e1f5a'
    //   },
    //   'clientCounter': 210,
    //   'phone': [
    //     {
    //       'telegram': true,
    //       'whatsapp': true,
    //       'viber': true,
    //       '_id': '618bbf281b1c4f00126538b3',
    //       'number': '123123123'
    //     },
    //     {
    //       'telegram': false,
    //       'whatsapp': false,
    //       'viber': true,
    //       '_id': '618bbf281b1c4f00126538b4',
    //       'number': '22'
    //     },
    //     {
    //       'telegram': true,
    //       'whatsapp': true,
    //       'viber': true,
    //       '_id': '61a479843d9f1f0012008518',
    //       'number': '444'
    //     }
    //   ],
    //   'riskStatus': 1,
    //   'clientType': 1,
    //   'status': 1,
    //   'businessConsultant': {
    //     '_id': '5e09cae50e8c600011e57b75',
    //     'access': {
    //       'communications': {
    //         'communications': true,
    //         'hr': true,
    //         'internalCommunication': true,
    //         'inspectionsAndReport': true
    //       },
    //       'dissemination': {
    //         'dissemination': true,
    //         'promotionMarketing': true,
    //         'publicationsPR': true,
    //         'salesCRM': true
    //       },
    //       'finance': {
    //         'finance': true,
    //         'income': true,
    //         'expenses': true,
    //         'assetsMaterialsRecords': true
    //       },
    //       'services': {
    //         'services': true,
    //         'interns': true,
    //         'projectManagement': true,
    //         'businessConsulting': true
    //       },
    //       'qualifications': {
    //         'qualifications': true,
    //         'qualityControl': true,
    //         'educationAcademy': true,
    //         'certificationsAwards': true
    //       },
    //       'businessDevelopment': {
    //         'businessDevelopment': true,
    //         'partnersAndReferals': true,
    //         'businessClubsAssociacions': true,
    //         'publicInformationService': true
    //       },
    //       'executive': {
    //         'executive': true,
    //         'officeOfFounder': true,
    //         'officeOfCorpAffairs': true,
    //         'officeOfTheCEO': true
    //       },
    //       'commercialOffers': {
    //         'commercialOffers': true
    //       }
    //     },
    //     'kpi': {
    //       'bonusToBePaid': 0,
    //       'earned': 0,
    //       'potential': 33700
    //     },
    //     'role': 'ceo',
    //     'position': '5e09ca9e0e8c600011e57b73',
    //     'firstName': 'vitali',
    //     'lastName': 'sharametsyeu',
    //     'email': 'vs@b-b.center',
    //     'username': 'vitali sharametsyeu',
    //     'company': '5e09ca8f0e8c600011e57b72',
    //     'login': 'vs@bb.center',
    //     'salt': '41785009de2df606557857599167132d',
    //     'hash': '9e18a5fc5009755d579afd0d63304d5aa3a913c84d097946eb308d520415406f9e01be3beb4b7b5417d4be7e3133107f6dd4e12d0a9eef3d9a56a847f20b44d691663c335c950f9f007371f9e171f214e88010d7404557460c4e283079a90e749f218ad908c47e5821f8c90332ad295be336571b0b0674cd87db0a22e3b783f02b790c4dcb4ba625d8be1f39847e9e02b58b57d9ee5f1c0cc254f00a5bcc235899012eeb393f7a202cf14d99496de17116bd72f7586bc8b46694e6d50aa8367ee49a0d925c501f31a4377558aa477f1ce699c05202b79454fe2cb794cc3a076fa07e6866af567fe821b8090695922807ba803a61e3b1a58056cada3694b1e814b495f0ab775bc9d199606cd253882e455f896146ec4ab9d2bc7a58fb67e005f92240b0252e715ab18c482d3954211cf15eae5c2d71015d1cd49891687892369f59ad18e09efbb7dda40e1a4248c01145a2f0f46a3c7901668fa1105218e72fc4f707c0d04455f8be2fc339d9ee844babf31b03f90d3e5c78044563366543a2d3a1e22277c58d27327c9be43f7b0f389c2b8e7a6c278f74968641a80e5c9dce8bc68f7de69f7504a0266b7cd12b1f12b9db05d4d397fbd5e47b5153bbeffd30a64f873d963c43e8e31a99f185d0c653dbacbdd1f5bef4ae5bc5fa6e4e08c7ced4a762eeb2fc2286d1675b08c261a6071048b1f3a58cea14369a6ae60264f69da0',
    //     'createdAt': '2019-12-30T10:01:10.013Z',
    //     'updatedAt': '2022-02-03T16:45:43.853Z',
    //     '__v': 0,
    //     'image': {
    //       '_id': '5e7b44ccc1a69b001949f6fe',
    //       'fieldname': 'uploadFile',
    //       'label': 'K4AFFG.jpg',
    //       'path': 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/uploads/5e09ca8f0e8c600011e57b72/images/1585136843654-K4AFFG.jpg',
    //       'key': 'uploads/5e09ca8f0e8c600011e57b72/images/1585136843654-K4AFFG.jpg',
    //       'createdAt': '2020-03-25T11:47:24.501Z',
    //       'updatedAt': '2020-03-25T11:47:24.501Z',
    //       '__v': 0
    //     },
    //     'isNotAssigned': false,
    //     'massMailingCheck': true,
    //     'phone': '123',
    //     'isHrIncluded': false,
    //     'deleteStatus': 1,
    //     'id': '5e09cae50e8c600011e57b75'
    //   },
    //   'visaExpiration': '2021-08-31T15:24:07.705Z',
    //   'lastFly': '2021-08-30T12:24:30.469Z',
    //   'birthday': '2021-08-30T12:24:30.474Z',
    //   'firstName': 'A Muffin',
    //   'lastName': 'Muff',
    //   'nickName': 'A Muffin Muffа а',
    //   'contactType': 1,
    //   'clientCode': 'BB-DMCC-1',
    //   'company': '5e09ca8f0e8c600011e57b72',
    //   'createdAt': '2021-08-30T12:26:16.370Z',
    //   'updatedAt': '2022-04-11T11:40:09.655Z',
    //   'invoiceCounter': {},
    //   '__v': 15,
    //   'image': null,
    //   'id': '612cce686121910019e80b26'
    // }
  ]
}
const getters = {
  emailStore: state => state.emailStore,
  updateThreadStore: state => state.updateThreadStore,
  activeEmail: state => state.activeEmail,
  inboxEmail: state => state.inboxEmail,
  sentEmail: state => state.sentEmail,
  trashEmail: state => state.trashEmail,
  savedEmail: state => state.savedEmail,
  todoEmail: state => state.todoEmail,
  draftEmail: state => state.draftEmail
}
const actions = {
  setEmailStore ({commit}, data) {
    commit(types.SET_EMAIL_STORE, {data})
  },
  setUpdateThreadStore ({commit}, data) {
    commit(types.SET_UPDATE_THREAD_STORE, {data})
  },
  setActiveEmail ({commit}, data) {
    commit(types.SET_ACTIVE_EMAIL, {data})
  },
  setInboxEmail ({commit}, data) {
    commit(types.SET_INBOX_EMAIL, {data})
  },
  setSentEmail ({commit}, data) {
    commit(types.SET_SENT_EMAIL, {data})
  },
  setTrashEmail ({commit}, data) {
    commit(types.SET_TRASH_EMAIL, {data})
  },
  setSavedEmail ({commit}, data) {
    commit(types.SET_SAVED_EMAIL, {data})
  },
  setTodoEmail ({commit}, data) {
    commit(types.SET_TODO_EMAIL, {data})
  },
  setDraftEmail ({commit}, data) {
    commit(types.SET_DRAFT_EMAIL, {data})
  }
}
const mutations = {
  [types.SET_EMAIL_STORE] (state, {data}) {
    state.emailStore = data
  },
  [types.SET_UPDATE_THREAD_STORE] (state, {data}) {
    state.updateThreadStore = data
  },
  [types.SET_ACTIVE_EMAIL] (state, {data}) {
    state.activeEmail = data
  },
  [types.SET_INBOX_EMAIL] (state, {data}) {
    state.inboxEmail = data
  },
  [types.SET_SENT_EMAIL] (state, {data}) {
    state.sentEmail = data
  },
  [types.SET_TRASH_EMAIL] (state, {data}) {
    state.trashEmail = data
  },
  [types.SET_SAVED_EMAIL] (state, {data}) {
    state.savedEmail = data
  },
  [types.SET_TODO_EMAIL] (state, {data}) {
    state.todoEmail = data
  },
  [types.SET_DRAFT_EMAIL] (state, {data}) {
    state.draftEmail = data
  }}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Email/modules/store.js